import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * a custom operator to emulate RxJs's "take(1)"" native operator
 */
export function takeOnce<T = any>() {
  return (source$: Observable<T>): Observable<T> => {
    return source$.pipe(take(1));
  };
}
